import { render, staticRenderFns } from "./m-slide-v2.vue?vue&type=template&id=15643c5e&scoped=true"
import script from "./m-slide-v2.vue?vue&type=script&lang=js"
export * from "./m-slide-v2.vue?vue&type=script&lang=js"
import style0 from "./m-slide-v2.vue?vue&type=style&index=0&id=15643c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15643c5e",
  null
  
)

export default component.exports